// Demo dashboard numbers: used for the new-user sample state and on the landing pages.
export const DEMO_CALORIE_STATS = {
  last_session_cal: 385,
  week_total_cal: 1240,
  sessions_this_week: 3,
  weekly_trend: [
    { label: 'W-5', calories: 890, is_current: false },
    { label: 'W-4', calories: 1050, is_current: false },
    { label: 'W-3', calories: 780, is_current: false },
    { label: 'W-2', calories: 1180, is_current: false },
    { label: 'W-1', calories: 1350, is_current: false },
    { label: 'NOW', calories: 1240, is_current: true },
  ],
};

export const DEMO_CARDIO_STATS = {
  week_minutes: 72,
  week_sessions: 3,
  week_calories: 540,
  week_distance_km: 8.4,
  week_skipped: 0,
  target_minutes: 90,
  planned_sessions: 4,
  streak_weeks: 3,
  weekly_trend: [
    { label: 'W-5', minutes: 40, is_current: false },
    { label: 'W-4', minutes: 55, is_current: false },
    { label: 'W-3', minutes: 30, is_current: false },
    { label: 'W-2', minutes: 65, is_current: false },
    { label: 'W-1', minutes: 80, is_current: false },
    { label: 'NOW', minutes: 72, is_current: true },
  ],
};
